/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { Tooltip } from 'react-tooltip'
import Icon from '../../../icon'

import {
  Container,
  Header,
  IconWrapper,
  TitleWrapper,
  Value,
  TooltipWrapper,
} from './styles'
import { ShortFinanceCardProps } from './props'
import { numberToCurrency } from '../../../../helpers/helper-currency'

const ShortFinanceCard = ({ data }: ShortFinanceCardProps) => (
  <Container>
    <Header>
      <IconWrapper>
        <Icon name={data.iconName} />
      </IconWrapper>
      <TitleWrapper>
        <h3>{data.title}</h3>
      </TitleWrapper>
      <TooltipWrapper data-tooltip-id="my-tooltip" data-tooltip-content={data.description}>
        <Icon name="info" />
      </TooltipWrapper>
      <Tooltip id="my-tooltip" />
    </Header>
    <Value>{numberToCurrency(data.value)}</Value>
  </Container>
)

export default ShortFinanceCard
